import { usePostApi } from '@stagapps/redux-utils'
import { Button, Form, Select, Space } from 'antd'
import { apiCallGeneratorByName } from 'app/apiCalls/surveys/create'
import ValidButton from 'common/ui/form/ValidButton'
import useEffectSkipFirstRender from 'hooks/useEffectSkipFirstRender'
import { useNavigate } from 'react-router-dom'
import { renderErrorMessage } from 'utils/getErrorMessage'
import WelcomeTemplate from './WelcomeTemplate'

function Question2() {
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const { data, post, isLoading, error } = usePostApi(
    apiCallGeneratorByName('survey2'),
    { resourceName: 'data' }
  )

  useEffectSkipFirstRender(() => {
    if (data) {
      navigate(`/welcome/questions/3`)
    }
  }, [data])

  const onFinish = values => {
    post({
      ...values,
      question_code: '1002',
      survey_type: 1001,
      question_type: 1001
    })
  }

  return (
    <WelcomeTemplate
      quotes={
        'Tại Stag, chúng tôi đồng hành cùng bạn trên hành trình chinh phục mục tiêu tài chính của mình, vươn đến tầm cao mới.'
      }
      author={'Stag Invest'}
    >
      <Form
        form={form}
        requiredMark={false}
        onFinish={onFinish}
        initialValues={{ answer_codes: '1002_001' }}
        labelCol={{ span: 24 }}
      >
        <Form.Item
          validateStatus={!!error ? 'error' : null}
          hasFeedback
          help={error ? renderErrorMessage(error) : ''}
          label={'Chức vụ của bạn là gì?'}
          className="md:max-w-[78%] mx-auto text-left"
          name="answer_codes"
          rules={[
            {
              required: true,
              message: 'Vui lòng chọn 1 câu trả lời'
            }
          ]}
        >
          <Select options={options} />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" ghost>
              Trở về
            </Button>
            <ValidButton
              form={form}
              type="primary"
              htmlType="submit"
              btnTitle="Tiếp tục"
            />
          </Space>
        </Form.Item>
      </Form>
    </WelcomeTemplate>
  )
}

export default Question2

const options = [
  {
    label: 'Lãnh đạo/ Giám đốc cấp cao',
    value: '1002_001'
  },
  {
    label: 'Quản lý / Trưởng bộ phận',
    value: '1002_002'
  },
  {
    label: 'Nhân viên',
    value: '1002_003'
  },
  {
    label: 'Hành nghề tự do',
    value: '1002_004'
  },
  {
    label: 'Tự kinh doanh',
    value: '1002_005'
  },
  {
    label: 'Khác',
    value: '1002_006'
  }
]
